import React from "react"
import { graphql } from "gatsby"
import styles from "../styles/global.module.scss"
import BackgroundImage from "gatsby-background-image"

// Components
import Layout from "../components/layout/layout"
import JobInformation from "../components/work/job-information"

import { useGetTokens } from "../hooks/useGetTokens"
import convertTokens from "../helpers/convertTokens"
import setSeoData from "../helpers/setSeoData"

export default ({ data, location }) => {
  // Get metadata
  const metadata = useGetTokens()

  const job = data.projects.frontmatter
  let featuredImage
  if (job.featuredImage) {
    featuredImage = job.featuredImage.childImageSharp.fluid
  }

  let seo_data = setSeoData(job)

  return (
    <Layout location={location} seo_data={seo_data}>
      <BackgroundImage id={styles.workPageFeatureImg} fluid={featuredImage} />
      <div id={styles.jobContainer} className={styles.containerWide}>
        <h1>{job.title}</h1>
        <div id={styles.jobContain} className={styles.flexWrapper}>
          <JobInformation job={job} />
          <div id={styles.jobContent}>
            <div
              dangerouslySetInnerHTML={{
                __html: convertTokens(data.projects.html, metadata),
              }}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($slug: String!) {
    projects: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        description
        meta {
          title
          description
          page_visible
        }
        categories
        location
        end_date
        start_date
        subtitle
        featuredImage {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
